import { useLocation } from "react-router-dom";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import { useDispatch, useSelector } from "react-redux";
import { isNoteSelector, selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { setBasicDialogOpenFor, setOpenToast } from "../../../store/helpers/helperReducers";
import { errorMessage } from "../../../utils/helpers";
import { useState } from "react";
import { useAddOrUpdateNoteMutation, useDeleteNoteMutation, useGetAllNotesQuery } from "../../../store/api/devices/deviceApiSlice";
// import { isSpecialChars } from "../../../utils/validations";

export const useNotesDisplay = () => {

const location = useLocation()
const locationPath = location?.pathname.split("/");
const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
const deviceObjectKey = selectedDevice?.objectKey || locationPath[2];
const dispatch = useDispatch()
const [deleteNote] = useDeleteNoteMutation()
const args = {deviceKey: deviceObjectKey};
const { data, isError, isLoading,refetch } = useGetAllNotesQuery(args, { pollingInterval: 30000 });
const [addOrUpdateNote] = useAddOrUpdateNoteMutation();
const [note, setNote] = useState("");

const handleDeleteNote = async (noteId: number, actionName: string) => {
  let response: any;
  try {
    if (actionName.match("delete")) {
      response = await deleteNote({ noteId });
      if (response?.error) throw response?.error;
      if (response.data?.status === 200) {
        dispatch(
          setOpenToast({
            openToast: true,
            toastType: "success",
            message: `${noteId} has been deleted successfully`,
          })
        );
      }
    }
    refetch()
  } catch (error: any) {
    dispatch(
      setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) })
    );
  }
};


const submitHandler = async () => {

  const trimmedNote = note.trim();

  if (!trimmedNote) {
    dispatch(setOpenToast({ openToast: true, toastType: "error", message: "Note cannot be empty!" }));
    return;
  }

  // if (isSpecialChars(trimmedNote)) {
  //   dispatch(
  //     setOpenToast({
  //       openToast: true,
  //       toastType: "error",
  //       message: "Special characters are not allowed!",
  //     })
  //   );
  //   return;
  // }

  // Check for max length
  if (trimmedNote.length > 255) {
    dispatch(
      setOpenToast({
        openToast: true,
        toastType: "error",
        message: "Note length should be less than 255 characters!",
      })
    );
    return;
  }

  try {
    const responseData = await addOrUpdateNote({ deviceKey: deviceObjectKey, note }).unwrap();

    if (responseData?.status === 201) {
      dispatch(
        setOpenToast({
          openToast: true,
          toastType: "success",
          message: "Note added successfully",
        })
      );
      setNote("");
      dispatch(setBasicDialogOpenFor(undefined));
    } else {
      dispatch(
        setOpenToast({
          openToast: true,
          toastType: "error",
          message: "Unexpected success response from server",
        })
      );
    }
  } catch (error: any) {
    dispatch(
      setOpenToast({
        openToast: true,
        toastType: "error",
        message: errorMessage(error),
      })
    );
  }
  refetch();
};

const handleEditNote = async (noteId: number, updatedText: string) => {
  const trimmedText = updatedText.trim();

  if (!trimmedText) {
    dispatch(
      setOpenToast({
        openToast: true,
        toastType: "error",
        message: "Note cannot be empty!",
      })
    );
    return;
  }

  // if (isSpecialChars(trimmedText)) {
  //   dispatch(
  //     setOpenToast({
  //       openToast: true,
  //       toastType: "error",
  //       message: "Special characters are not allowed!",
  //     })
  //   );
  //   return;
  // }

  if (trimmedText.length > 255) {
    dispatch(
      setOpenToast({
        openToast: true,
        toastType: "error",
        message: "Note length should be less than 255 characters!",
      })
    );
    return;
  }

  try {
    const response = await addOrUpdateNote({
      noteId,
      deviceKey: deviceObjectKey,
      note: trimmedText
    }).unwrap();

    if (response?.status === 204) {
      dispatch(
        setOpenToast({
          openToast: true,
          toastType: "success",
          message: "Note updated successfully!",
        })
      );
    }

    refetch();

  } catch (error: any) {
    dispatch(
      setOpenToast({
        openToast: true,
        toastType: "error",
        message: errorMessage(error),
      })
    );
  }
};



return {
isError,
data,
isLoading,
handleDeleteNote,
submitHandler,
note,
setNote,
handleEditNote,
}
}